import React from "react";
import PropTypes from "prop-types";

export default function DeliveryIcon({ fill, size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
    >
      <g transform="translate(-1592 -278)">
        <rect
          width="20"
          height="20"
          transform="translate(1592 278)"
          fill="none"
        />
        <g>
          <g
            transform="translate(1593 283)"
            fill="none"
            stroke={fill}
            strokeWidth="1"
          >
            <rect width="13" height="9" stroke="none" />
            <rect x="0.5" y="0.5" width="12" height="8" fill="none" />
          </g>

          {/* Cabine */}
          <g transform="translate(1605 285.428)">
            <path
              d="M 1 1.03 L 1 5.57 L 5 5.57 C 4.998 4.26 4.94 3.03 4.35 2.26 C 3.79 1.54 2.69 1.13 1 1.03 Z"
              fill="#fff"
              stroke={fill}
            />
          </g>

          {/* Roda traseira */}
          <g
            transform="translate(1595 290)"
            fill="#fff"
            stroke={fill}
            strokeWidth="1"
          >
            <circle cx="2" cy="2" r="2" stroke="none" />
            <circle cx="2" cy="2" r="1.5" fill="none" />
          </g>

          {/* Roda dianteira */}
          <g
            transform="translate(1606 290)"
            fill="#fff"
            stroke={fill}
            strokeWidth="1"
          >
            <circle cx="2" cy="2" r="2" stroke="none" />
            <circle cx="2" cy="2" r="1.5" fill="none" />
          </g>
        </g>
      </g>
    </svg>
  );
}

DeliveryIcon.defaultProps = {
  size: "20",
  fill: "#4b4b4b",
};

DeliveryIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string,
};
